// extracted by mini-css-extract-plugin
module.exports = {"root":"date_root__zDUsg","field":"date_field__2fnSn"};